/** @format **/
import ApiCollectionResponseInterface from '../api/ApiCollectionResponseInterface';

export const apiShortPlatformIccidRmoHistory = 'platform_iccid_rmo_histories';
export const apiShortPlatformImsiRange = 'platform_imsi_ranges';

export interface PlatformIccidRmoHistoryCollection extends ApiCollectionResponseInterface {
    'hydra:member': Array<PlatformIccidRmoHistory>;
}

export interface PlatformIccidRmoHistory {
    readonly '@id': string;
    readonly '@type': string;
    readonly id: number;
    platformResellerId: number;
    platformReseller: string;
    platformIccidPoolNumberId: number;
    platformIccidPoolNumber: string;
    rmoModel: number;
    createdAt: string;
    startDate: string;
    endDate: string | null;
    rmoType: number;
}
